/** Counts at or past one inbox page read as "50+" rather than an exact total. */
export function inboxBadgeLabel({
  count,
  cap,
}: {
  count: number;
  cap: number;
}): string {
  return count >= cap ? `${cap}+` : String(count);
}
